// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PaymentStatus_container__C68K9 {
  width: 100%;
  background: var(--color-neutral-100);
  color: black;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  border: 1px solid var(--color-neutral-600);
  border-radius: 10px;
}

@media screen and (min-width: 992px) {
  .PaymentStatus_container__C68K9 {
    width: 70%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Styles/PaymentStatus.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,oCAAoC;EACpC,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":[".container {\n  width: 100%;\n  background: var(--color-neutral-100);\n  color: black;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 40px 20px;\n  border: 1px solid var(--color-neutral-600);\n  border-radius: 10px;\n}\n\n@media screen and (min-width: 992px) {\n  .container {\n    width: 70%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PaymentStatus_container__C68K9`
};
export default ___CSS_LOADER_EXPORT___;
